<template>
  <div class="row">
    <el-dialog
      left
      title="Add Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      @close="handleCancel()"
      :visible.sync="isShow"
      style="margin: 0 auto"
      class="addCompanyModal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <div class="row">
        <div class="col-12">
          <div class="addCompanySearchTitle">Search for a Company</div>
          <!-- <div class="form-group has-search flex-grow-1"> -->
          <div style="padding-top: 8px; position: relative">
            <input
              type="text"
              v-model="companySearchString"
              @keyup="autocompleteFetch"
              class="form-control addCompanySearch"
              aria-controls="datatables"
              placeholder="Search for a Company"
            />
            <!-- <span class="fa fa-search " style="margin-top:0;"></span> -->
            <div class="icon-container" v-if="showLoader">
              <i class="searchloader"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="showBadges" class="d-flex addCompanyBadgesMainDiv">
          <div
            v-for="(item, index) in checkedData"
            :key="index"
            class="d-flex addCompanyBadgesLoopDiv"
          >
            <div class="flex-grow-1 addCompanyBadgesNameDiv">
              {{ item.properties.name }}
            </div>
            <!-- <div style="padding-right: 11px;font-size: 12px;line-heigth:15px"> -->
            <div class="addCompanyBadgesCrossIconDiv">
              <i class="fa fa-close" @click="removeCompany(item, index)"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div style="margin-left: 155px;margin-top: 10px;" v-if="showLoader">
          <div class="AddCompanyLoader"></div>
        </div>-->
        <div v-if="showSuggestions">
          <div class="addCompanyResultsDiv">
            {{ crunchBaseData.length }} Results
          </div>
          <div v-if="crunchBaseData.length > 0" style="padding-left: 15px">
            <!-- <div>{{crunchBaseData.length}} Results</div> -->
            <div class="addCompanyBodyLayoutDiv">
              <div v-for="(item, index) in crunchBaseData" :key="index">
                <div
                  class="d-flex addCompanyBodyMainDiv"
                  v-if="!item.isDuplicate"
                >
                  <div class="addCompanyBodyCheckBoxMainDiv">
                    <input
                      type="checkbox"
                      :id="`company-checkbox-${item.properties.permalink}`"
                      v-model="item.checked"
                      :disabled="checkedData.length>0 && !(item.properties.name === checkedData[0].properties.name)"
                      class="regular-checkbox"
                      style="cursor: pointer"
                      @change="checkBoxChangeEvent(item)"
                    />
                  </div>
                  <div class style="padding-right: 5px; padding-bottom: 10px">
                    <img
                      class="rounded-circle"
                      style="height: 24px; width: 24px"
                      :src="getImageUrl(item.properties.profile_image_url)"
                    />
                  </div>
                  <div class="addCompanyBodyNameDiv">
                    {{ item.properties.name }}
                  </div>
                </div>
                <div
                  class="d-flex addCompanyBodyMainDiv"
                  v-if="item.isDuplicate"
                  style="background-color: #e0e0e0"
                >
                  <div class="addCompanyBodyCheckBoxMainDiv">
                    <input
                      type="checkbox"
                      :id="`company-checkbox-${item.properties.permalink}`"
                      v-model="item.checked"
                      class="regular-checkbox"
                      style="background-color: #e0e0e0"
                      disabled
                    />
                  </div>
                  <div class style="padding-right: 5px; padding-bottom: 10px">
                    <img
                      class="rounded-circle"
                      style="height: 24px; width: 24px"
                      :src="getImageUrl(item.properties.profile_image_url)"
                    />
                  </div>
                  <div class="addCompanyBodyNameDiv">
                    {{ item.properties.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="crunchBaseData.length" style="padding-left: 15px">
            <div class="addCompanyBodyAnywayDiv">
              If your company is not listed above, you can
              <span
                class="addCompanyBodyAnywaySpan"
                @click="addAnyway(companySearchString)"
                >Add Anyway</span
              >
              for now and we will continue to search “{{ companySearchString }}”
              in the mean time.
            </div>
          </div>

          <div v-if="crunchBaseData.length == 0" style="padding-left: 15px">
            <div class="addCompanyBodyAnywayDiv">
              We will continue to search for “{{ companySearchString }}” in the
              mean time
              <span
                class="addCompanyBodyAnywaySpan"
                @click="addAnyway(companySearchString)"
                >Add Anyway</span
              >
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer" style>
        <div style="border: 0.8px solid #ededed; opacity: 1"></div>
        <div class="col-xl edit-company-action-button-row" style="padding: 0px">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancel"
          >
            Cancel
          </button>
          <button
            type="button"
            :disabled="!showSaveButton"
            @click.prevent="writeToServer"
            class="todo-form-submit-button btn btn-primary"
          >
            Continue
            <!-- <i class="nc-icon nc-refresh-02 spinner" v-if="showSpinner"></i> -->
            <b-spinner
              v-if="showSpinner"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { Select, Option } from "element-ui";
import api from "../../../axios_api";
import { Company } from "../../../models/Company";
import config from "../../../../config/settings";
import {
  cbAdapter,
} from "../../../util";

const CRUNCHBASE_BASE_URL = "https://api.crunchbase.com/v3.1/";
const CRUNCHBASE_USER_KEY = "f488b788b922f095807326b936073e45";

export default {
  name: "spv-add-company",
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
    },
  },
  data() {
    return {
      companySearchString: "",
      crunchBaseData: [],
      showSuggestions: false,
      aborter: null,
      checkedData: [],
      showBadges: false,
      isSaving: true,
      showLoader: false,
      showSpinner: false,
      showSaveButton: false,
      refreshCheck: 0,
      inProgressPortfolioCall: false,
    };
  },
  computed: {
    isShow: {
      get() {
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
        this.$emit("input", this.value);
      },
    },
    companies() {
      //  let companies = this.$store.getters["portfolio/portfolioData"];

      let companies = this.$store.getters["portfolio/portfolioAddCompany"];
      return companies;
    },
  },
  methods: {
    handleCancel() {
      this.isShow = false;
      this.crunchBaseData = [];
      this.showSuggestions = false;
      this.aborter = null;
      this.companySearchString = "";
      this.checkedData = [];
      this.showBadges = false;
      this.showLoader = false;
      this.showSpinner = false;
      this.showSaveButton = false;
    },
    // autocompleteCompanyEndPoint(event) {
      
    //   this.autocompleteFetch(event.target.value);
      
    // },
    autocompleteFetch(event) {
      const self = this;
      this.crunchBaseData = [];
      this.showSuggestions = false;
      this.showLoader = true;
      // cancel pending request if any
      if (this.aborter) this.aborter.abort();
      // make our request cancellable
      this.aborter = new AbortController();
      const signal = this.aborter.signal;
      if (event.target.value.length > 0) {
        
        api
          .get(`search?key=${event.target.value}`)
          .then((response) => {
            // quick fix adapter
            let data = cbAdapter(response); 

            // this.showSuggestions = true;
            // this.crunchBaseData = [];
            if (data.data.items.length == 0) {
              this.showSuggestions = true;
              this.showLoader = false;
            }
            data.data.items.map((item) => {
              let id = `company-checkbox-${item.properties.permalink}`;
              let obj = {};
              obj = JSON.parse(JSON.stringify(item));
              let index = self.checkedData.findIndex((items) => {
                return items.properties.permalink == item.properties.permalink;
              });
              if (index >= 0) {
                obj.checked = true;
              } else {
                obj.checked = false;
              }
              let duplicateIndex = self.companies.findIndex((items) => {
                return items.permalink == item.properties.permalink;
              });
              if (duplicateIndex >= 0) {
                obj.isDuplicate = true;
              } else {
                obj.isDuplicate = false;
              }
              self.crunchBaseData.push(obj);
              if (self.crunchBaseData.length == data.data.items.length) {
                this.showSuggestions = true;
                this.showLoader = false;
              }
            });
            //this.crunchBaseData = data.data.items;
            // this.showSuggestions = true;
            self.aborter = null;
          })
          .catch((err) => {
            if (err.name != "AbortError") {
              console.log("error", err);
            }
          });
      } else {
        this.crunchBaseData = [];
        this.showSuggestions = false;
        this.showLoader = false;
        self.aborter = null;
      }
    },
    checkBoxChangeEvent(data) {
      let id = `company-checkbox-${data.properties.permalink}`;
      this.showBadges = false;
      this.showSaveButton = false;
      if (document.getElementById(id).checked) {
        this.checkedData.push(data);
        this.showBadges = true;
        this.showSaveButton = true;
      } else {
        // this.checkedData.hasOwnProperty(id) ? delete this.checkedData[id] : "";
        let index = this.checkedData.findIndex((item) => {
          return item.properties.permalink == data.properties.permalink;
        });
        if (index >= 0) {
          this.checkedData.splice(index, 1);
          this.showBadges = true;
          this.showSaveButton = true;
        }
      }
      if (this.checkedData.length == 0) {
        this.showBadges = false;
        this.showSaveButton = false;
      }
    },
    removeCompany(item, index) {
      this.showBadges = false;
      this.showSaveButton = false;
      this.checkedData.splice(index, 1);
      if (item.properties && item.properties.permalink) {
        let id = `company-checkbox-${item.properties.permalink}`;
        if (
          document.getElementById(id) &&
          document.getElementById(id).checked
        ) {
          document.getElementById(id).checked = false;
        }
      }
      //this.showBadges = true;
      if (this.checkedData.length != 0) {
        this.showBadges = true;
        this.showSaveButton = true;
      }
    },
    addAnyway(param) {
      let obj = {};
      obj.properties = {};
      obj.properties.name = param;
      let index = this.checkedData.findIndex((item) => {
        if (!item.properties.permalink) {
          return item.properties.name == param;
        }
      });
      let duplicateIndex = this.companies.findIndex((item) => {
        return item.name == param;
      });
      if (duplicateIndex >= 0) {
        this.$toaster.success(
          `The company '${param}' is already present in your portfolio`
        );
      }
      if (index < 0 && duplicateIndex < 0) {
        this.checkedData.push(obj);
      }
      if (this.checkedData.length > 0) {
        this.showBadges = true;
        this.showSaveButton = true;
      } else {
        this.showBadges = false;
        this.showSaveButton = false;
      }
    },
    writeToServer() {
      let data = JSON.parse(JSON.stringify(this.checkedData));
      const self = this;
      this.showSaveButton = false;
      this.showSpinner = true;
      data.map((item) => {
        let serverData = new Company({});
        serverData.name = item.properties.name;
        serverData.cost = 0;
        serverData.value = 0;
        serverData.direct = "Direct";
        if (item.properties.permalink) {
          serverData.website = item.properties.homepage_url
            ? item.properties.homepage_url
            : "";
          serverData.facebook = item.properties.facebook_url
            ? item.properties.facebook_url
            : "";
          serverData.linkedin = item.properties.linkedin_url
            ? item.properties.linkedin_url
            : "";
          serverData.twitter = item.properties.twitter_url
            ? item.properties.twitter_url
            : "";
          serverData.logo_url = item.properties.profile_image_url
            ? item.properties.profile_image_url
            : "";
          serverData.permalink = item.properties.permalink
            ? item.properties.permalink
            : "";
          serverData.cb_data = item;
        } else {
          //serverData.permalink = "";
          serverData.data_status = "Confirmed";
          serverData.company_status = "Unknown";
        }
        serverData
          .validate()
          .then((validateResponse) => {
            return serverData.writeToServer();
          })
          .then((dataFromServer) => {
            //self.refreshPortfolioTable(serverData);
            if (
              serverData.data_status == "Unconfirmed" &&
              serverData.permalink &&
              serverData.permalink != ""
            ) {
              let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;
              api
                .post(url, {
                  encrypt: {
                    data: {
                      company: serverData,
                      confirmedCompany: serverData.cb_data
                        ? serverData.cb_data
                        : {},
                    },
                  },
                })
                .then((confirmData) => {
                  if (this.inProgressPortfolioCall) {
                    return;
                  }
                  this.inProgressPortfolioCall = true;
                  this.$store
                    .dispatch("portfolio/_apiFetchPortfolio")
                    .then((data) => {
                      this.inProgressPortfolioCall = false;
                      if (self.$parent && self.$parent.tabulator) {
                        let data =
                          self.$store.getters["portfolio/portfolioData"];
                        self.$parent.tabulator.replaceData(data);
                        self.$parent.checkDataStatus();
                      } else {
                        if (
                          self.$parent &&
                          self.$parent.$refs &&
                          self.$parent.$refs.directInvestRef &&
                          self.$parent.$refs.directInvestRef.tabulator
                        ) {
                          let data =
                            self.$store.getters["portfolio/portfolioData"];
                          self.$parent.$refs.directInvestRef.tabulator.replaceData(
                            data
                          );
                          self.$parent.$refs.directInvestRef.checkDataStatus();
                        }
                      }
                      self.$toaster.success(
                        `${serverData.name} Saved Successfully`
                      );
                      self.$store.dispatch("contacts/getContacts");
                      self.$store.dispatch("suggestions/getSuggestions");
                    })
                    .catch((error) => {
                      this.inProgressPortfolioCall = false;
                      console.log("refresh error", error);
                    });
                  //this.$store.dispatch("portfolio/start");
                  //this.$store.dispatch("offering/getOfferings");
                  self.handleCancel();
                })
                .catch((err) => {
                  this.$toaster.error("Unable to confirm company.");
                  self.handleCancel();
                });
            } else {
              if (self.inProgressPortfolioCall) {
                return;
              }
              self.inProgressPortfolioCall = true;
              self.$store.dispatch("contacts/getContacts");
              self.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.inProgressPortfolioCall = false;
                  if (self.$parent && self.$parent.tabulator) {
                    let data = self.$store.getters["portfolio/portfolioData"];
                    self.$parent.tabulator.replaceData(data);
                  } else {
                    if (
                      self.$parent &&
                      self.$parent.$refs &&
                      self.$parent.$refs.directInvestRef &&
                      self.$parent.$refs.directInvestRef.tabulator
                    ) {
                      let data = self.$store.getters["portfolio/portfolioData"];
                      self.$parent.$refs.directInvestRef.tabulator.replaceData(
                        data
                      );
                    }
                  }
                  self.$toaster.success(
                    `${serverData.name} Saved Successfully`
                  );
                })
                .catch((error) => {
                  self.inProgressPortfolioCall = false;
                  console.log("refresh error", error);
                });
              //self.$store.dispatch("portfolio/start");
              //self.$store.dispatch("offering/getOfferings");
              self.handleCancel();
            }
          })
          .catch((error) => {
            console.log("validateResponse error", error);
            self.$toaster.error(error.error);
            self.showSaveButton = true;
            self.showSpinner = false;
          }).finally(() => {
            this.$emit("getPortfolios");
          });
      });
    },
    refreshPortfolioTable(serverData) {
      const self = this;
      if (
        serverData.data_status == "Unconfirmed" &&
        serverData.permalink &&
        serverData.permalink != ""
      ) {
        let url = `${this.$route.params.account_id}/${this.$route.params.workspace_id}/company/confirm`;
        api
          .post(url, {
            encrypt: {
              data: {
                company: serverData,
                confirmedCompany: serverData.cb_data ? serverData.cb_data : {},
              },
            },
          })
          .then((confirmData) => {
            this.refreshCheck++;
            if (this.refreshCheck == this.checkedData.length) {
              this.$store
                .dispatch("portfolio/_apiFetchPortfolio")
                .then((data) => {
                  self.$toaster.success("Saved Successfully");
                  self.handleCancel();
                })
                .catch((error) => {
                  console.log("refresh error", error);
                });
              //this.$store.dispatch("portfolio/start");
              //this.$store.dispatch("offering/getOfferings");
            }
          })
          .catch((error) => {
            console.log("confirm company error", error);
          });
      } else {
        this.refreshCheck++;
        if (this.refreshCheck == this.checkedData.length) {
          this.$store
            .dispatch("portfolio/_apiFetchPortfolio")
            .then((data) => {
              self.handleCancel();
              self.$toaster.success("Saved Successfully");
            })
            .catch((error) => {
              console.log("refresh error", error);
            });
          //this.$store.dispatch("portfolio/start");
          //this.$store.dispatch("offering/getOfferings");
        }
      }
    },
    getImageUrl(image) {
      if (!image) {
        return;
      }
      // image.includes(
      //  "https://res-3.cloudinary.com/crunchbase-production/image/upload"
      //) ||
      if (
        image.includes(config.CRUNCHBASE_IMAGE_URL) ||
        image.includes("https://res") ||
        image.includes("static/img/generic-logo.png")
      ) {
        return image;
      }
      let imageId = image.slice(image.lastIndexOf("t_api_images/") + 13);
      if (!imageId || imageId.length == 0) {
        return image;
      }
      return `${config.CRUNCHBASE_IMAGE_URL}/${imageId}`;
    },
  },
};
</script>
<style lang="scss">
.addCompanyModal .el-dialog {
  padding-left: 20px;
  padding-right: 20px;
  min-height: 353px;
  width: 455px;
  max-width: 741px;
}

.addCompanyModal .el-dialog__title {
  line-height: 29px;
  font-size: 24px;
  color: #303133;
}
.addCompanyModal .el-dialog__header {
  padding-bottom: 0;
}

.addCompanyModal .el-dialog__footer {
  padding-left: 0;
  padding-right: 0;
  padding-top: 19px;
}

.addCompanyModal .el-dialog__body {
  min-height: 200px;
  padding-bottom: 0;
}

.style-2::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.style-2::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.style-2::-webkit-scrollbar-thumb {
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.regular-checkbox:checked:after {
  content: "\2713";
  font-weight: bolder;
  font-size: 14px;
  position: absolute;
  top: 0px;
  left: 3px;
  color: #ffffff;
}

.regular-checkbox:active,
.regular-checkbox:checked:active {
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
  //   inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.regular-checkbox:checked {
  background-color: #ff3f81;
  border: 1px solid #adb8c0;
  // box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
  //   inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
  //   inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.regular-checkbox {
  -webkit-appearance: none;
  background-color: #ffffff;
  border: 1px solid #707070;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 9px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  // margin-top: 3px;
}

.AddCompanyLoader {
  border: 15px solid #f3f3f3;
  border-radius: 50%;
  border-top: 15px solid #3498db;
  width: 100px;
  height: 100px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.addCompanySearch::after {
  content: "\f002";
  font-size: 14px;
  font-weight: 900;
}

.addCompanySearchTitle {
  font-size: 14px;
  line-height: 17px;
  color: #000000cc;
}

.addCompanySearch {
  margin: 0 !important;
  border: 1px solid #868686 !important;
}

.addCompanyBadgesMainDiv {
  padding-left: 15px;
  padding-top: 10px;
  padding-right: 15px;
  flex-wrap: wrap;
}

.addCompanyBadgesLoopDiv {
  margin-right: 5px;
  background: #e8e7fb 0% 0% no-repeat padding-box;
  border: 1px solid #cdccfa;
  border-radius: 15px;
  opacity: 1;
  padding-top: 2px;
  padding-bottom: 3px;
  height: 25px;
  margin-bottom: 5px;
}

.addCompanyBadgesNameDiv {
  letter-spacing: 0px;
  color: #0000009a;
  opacity: 1;
  font-size: 12px;
  // line-height: 15px;
  padding-left: 12px;
  white-space: nowrap;
  overflow: hidden; /*width: 77px;*/
  text-overflow: ellipsis;
  padding-right: 5px;
}

.addCompanyBadgesCrossIconDiv {
  padding-right: 5px;
  font-size: 12px;
  // line-height: 15px;
  color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.addCompanyResultsDiv {
  padding-left: 15px;
  padding-bottom: 14px;
  letter-spacing: 0px;
  color: #00000083;
  text-transform: uppercase;
  opacity: 1;
  font-size: 12px;
  line-height: 18px;
  padding-top: 20px;
}

.addCompanyBodyLayoutDiv {
  max-height: 225px;
  overflow: auto;
  width: 374px;
}

.addCompanyBodyMainDiv {
  border-bottom: 1px solid #f4f4f4; /*padding-bottom: 5px;padding-top: 5px;*/
  margin-bottom: 13px;
}

.addCompanyBodyCheckBoxMainDiv {
  padding-right: 10px;
  padding-left: 4px;
  padding-top: 1.9px;
  padding-bottom: 11.9px;
}

.addCompanyBodyNameDiv {
  font-size: 14px; /*line-height: 28px;*/
  color: #000000cc;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-top: 3px;
  padding-bottom: 14px;
}

.addCompanyBodyAnywayDiv {
  letter-spacing: 0px;
  color: #000000;
  font-size: 14px;
  line-height: 24px;
  word-break: break-word;
}

.addCompanyBodyAnywaySpan {
  letter-spacing: 0px;
  color: #5445f3;
  text-decoration: underline;
  cursor: pointer;
}

.icon-container {
  position: absolute;
  right: 10px;
  top: calc(50% - 10px);
}
.searchloader {
  position: relative;
  height: 20px;
  width: 20px;
  display: inline-block;
  animation: around 5.4s infinite;
}

@keyframes around {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.searchloader::after,
.searchloader::before {
  content: "";
  //background: white;
  position: absolute;
  display: inline-block;
  width: 100%;
  height: 100%;
  border-width: 2px;
  border-color: #333 #333 transparent transparent;
  border-style: solid;
  border-radius: 20px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  animation: around 0.7s ease-in-out infinite;
}

.searchloader::after {
  animation: around 0.7s ease-in-out 0.1s infinite;
  //background: transparent;
}
</style>
